import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { StatisticsPanelComponent } from '@connect-services/client/components/statistics/statistics-panel/statistics-panel.component';
import { StatisticService } from '@connect-services/client/services/statistic.service';
import { ProjectsService, StandardsService } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';
import { SnackBarService } from '@shared/client/services/snack-bar.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingComponent, RessourcesModule, StatisticsPanelComponent],
    selector: 'app-export-statistics',
    styleUrl: './export-statistics.component.scss',
    templateUrl: './export-statistics.component.html',
})
export class ExportStatisticsComponent implements OnInit {
    public readonly isLoading = signal(true);
    public projectName = '';
    public standardName = '';
    public today = new Date();

    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly projectsService = inject(ProjectsService);
    private readonly snackBarService = inject(SnackBarService);
    private readonly standardsService = inject(StandardsService);
    private readonly statisticService = inject(StatisticService);

    public async ngOnInit(): Promise<void> {
        const standardId = this.activatedRoute.snapshot.queryParamMap.get('standardId');
        const projectId = this.activatedRoute.snapshot.queryParamMap.get('projectId');

        if (!standardId || !projectId) {
            this.isLoading.set(false);
            this.snackBarService.openErrorSnackBar('noDataFound');

            return;
        }

        this.statisticService.standardId.set(standardId);
        this.statisticService.projectId.set(projectId);

        try {
            const [standard, project] = await Promise.all([
                firstValueFrom(this.standardsService.standardControllerGetOne({ id: standardId })),
                firstValueFrom(this.projectsService.projectControllerGetOne({ id: projectId })),
            ]);
            this.standardName = standard.name;
            this.projectName = project.name;
        } finally {
            this.isLoading.set(false);
        }
    }

    public printPage(): void {
        addEventListener('afterprint', () => {
            localStorage.removeItem('exportStatisticsZoneDelimiter');

            window.close();
        });

        print();
    }
}
